import styled from "styled-components";

const popupBgUrl = process.env.REACT_APP_MIDAS_HOST + '/assets/bg-popup.svg';

export const Container = styled.div`
	background: ${`url(${popupBgUrl}) var(--ticto-shape) center center`};
	background-size: cover;
	min-height: 300px;
	border-radius: 0.8rem;
`;

export const Popup = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	gap: 0.25rem;
	padding: 0.65rem 0 1rem;
	text-align: center;
`;

export const Title = styled.h1`
	font-size: 2rem;
	font-weight: bold;
	margin: 0;
	line-height: 1.1;
`;

export const Badge = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	margin: 0.15rem auto 0.75rem;

	svg {
		display: block;
		width: min(342px, 93vw);
		height: auto;
	}
`;

export const TextBlock = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.35rem;
	max-width: 88%;
	margin-bottom: 0.75rem;
`;

export const Description = styled.p`
	margin: 0;
	max-width: 34ch;
	line-height: 1.45;
`;
